import { Grid } from '@mui/material'
import { useField } from 'formik'
import React, { useState } from 'react'
import { getLocationType } from '.'
import TransformDisplayToEdition from '../../../../components/form/TransformDisplayToEdition'
import { useOptionalAdgroupContext } from '../../../../utils/hooks/adGroup/useAdgroupContext'
import { useAppTranslations } from '../../../../utils/hooks/useAppTranslations'
import { AdgroupSettingsQuery } from '../../../../__generated__/graphql'
import CSVAddressesUploadForm from './CSVAddressesUploadForm'
import { FormDialog } from '../../../../components/layout/FormDialog'
import { useCanEditAdGroup } from '../../../../utils/hooks/adGroup/useCanEditAdGroup'
import { useLocationTypeOptions } from './useLocationTypeOptions'
import RuleExclusion from './RuleExclusion'

export interface GeoTargetingFieldsProps {
  adgroupTargeting: AdgroupSettingsQuery['adGroup']['targeting']
  countryCode?: string
  readOnly?: boolean
  simulationMode?: boolean
}

export enum LocationTypesEnum {
  Cities = 'cities',
  Departements = 'departements',
  Regions = 'regions',
  Countries = 'countries',
}

const GeoTargetingFields: React.FC<GeoTargetingFieldsProps> = ({
  adgroupTargeting,
  countryCode,
  readOnly = false,
  simulationMode = false,
}): JSX.Element => {
  const canEditAdGroup = useCanEditAdGroup()
  const editable = simulationMode || (!readOnly && canEditAdGroup)
  const t = useAppTranslations()
  const [, typeMeta] = useField('targeting.type')
  const adgroupFromContext = useOptionalAdgroupContext()
  const adgroup = adgroupFromContext ?? {
    authorizedCountries: [],
    countryBlacklistRedirectUrl: null,
  }
  const { countries, geoExclusive } = adgroupTargeting?.geoTargeting ?? {}
  const [uploadAddressesModal, setUploadAddressesModal] = useState(false)

  const hasInitialExcludedCountries =
    geoExclusive === true &&
    getLocationType(adgroupTargeting?.geoTargeting) === LocationTypesEnum.Countries &&
    (countries?.length ?? 0) > 0

  const locationTypeOptions = useLocationTypeOptions(hasInitialExcludedCountries)

  return (
    <Grid container>
      <Grid size={10}>
        <TransformDisplayToEdition
          label="adgroup.geoTargeting.location"
          name={'targeting.' + typeMeta.value}
          text=""
          inputType={'geoLocationsPanel'}
          locationType={typeMeta.value}
          countryCode={countryCode}
          disableHoverEdition
          editable={editable}
          onImportCsv={simulationMode ? undefined : () => setUploadAddressesModal(true)}
          // The panel's top bar edits the rule and the location type itself
          ruleFieldName="targeting.geoExclusive"
          typeFieldName="targeting.type"
          locationTypeOptions={locationTypeOptions}
        />
      </Grid>
      {!simulationMode && uploadAddressesModal && (
        <FormDialog
          open={uploadAddressesModal}
          setOpen={() => setUploadAddressesModal(false)}
          title={t('adgroup.geoTargeting.importCSV')}
          maxWidth="sm"
        >
          <CSVAddressesUploadForm setOpen={() => setUploadAddressesModal(false)} />
        </FormDialog>
      )}
      {!simulationMode && (
        <Grid size={10} sx={{ mt: 1 }}>
          <RuleExclusion
            editable={editable}
            authorizedCountries={adgroup.authorizedCountries}
            countryBlacklistRedirectUrl={adgroup.countryBlacklistRedirectUrl}
          />
        </Grid>
      )}
    </Grid>
  )
}
export default GeoTargetingFields
